import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as effect from "../../core/effect";
import * as skill from "../skill/昊希娜";
import { Soulmark } from "../../core/soulmark";
import { Effect } from "../../core/effect";
import { Timing } from "../../core/timing";
import * as cond from "../../core/cond";
import * as pred from "../../core/pred";

export class 昊希娜 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(2849, "昊希娜", type.飞行·神秘, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark(
            [
                "先出手时，附加自身最大体力1/3的百分比伤害，并且造成的攻击伤害提高50%，体力低于对手时造成的攻击伤害额外提高50%；",
                "后出手时，受到的攻击伤害减少50%，并且吸取对手最大体力的1/3，体力低于1/2时吸取效果翻倍。",
            ],
            [
                new Effect(
                    new effect.增伤(50),
                    Timing.beforeDamage,
                    cond.若先出手,
                ),
                new Effect(
                    new effect.固伤(pred.自身最大体力的x分之一(3)),
                    Timing.actionBegin,
                    cond.若先出手,
                ),
                new Effect(
                    new effect.减伤(50),
                    Timing.beforeDamage,
                    cond.若后出手,
                ),
                new Effect(
                    new effect.吸取体力(pred.对手最大体力的x分之一(3), undefined, undefined, cond.若自身体力低于x分之一(2)),
                    Timing.actionBegin,
                    cond.若后出手,
                )
            ]
        );
        this.技能组 = [
            skill.盛世华光,
            skill.青鸟千羽,
            skill.空桑林语,
            skill.启明星辰击,
            skill.凌霄舞乾坤,
        ];
    }
}
